"use client";
import { jsxs as l, Fragment as k, jsx as e } from "react/jsx-runtime";
import { Slot as P } from "@radix-ui/react-slot";
import { Root as y, Action as A, Close as I, Viewport as j, Provider as R } from "@radix-ui/react-toast";
import { cva as m } from "class-variance-authority";
import * as z from "react";
import { Close as M, Microphone as S, InformationCircle as W, CheckCircle as D, WarningCircle as c } from "@videoblocks/react-icons";
import { cn as a } from "./index.es13.js";
import { Text as F } from "./index.es4.js";
const $ = m(
  "flex p-6 justify-between items-start rounded-sm border-l-8 shadow-level3-soft data-[state=open]:animate-in data-[state=open]:slide-in-from-right",
  {
    variants: {
      variant: {
        error: "border-l-red-500 bg-red-100 text-red-500",
        warning: "border-l-orange-500 bg-orange-100 text-orange-500",
        success: "border-l-green-500 bg-green-100 text-green-500",
        info: "border-l-blue-500 bg-blue-100 text-blue-500",
        neutral: "border-l-gray-500 bg-gray-200 text-black"
      }
    }
  }
), f = m("", {
  variants: {
    variant: {
      error: "fill-red-500",
      warning: "fill-orange-500",
      success: "fill-green-500",
      info: "fill-blue-500",
      neutral: "fill-black"
    }
  }
}), q = {
  error: c,
  warning: c,
  success: D,
  info: W,
  neutral: S
}, B = (t) => {
  const r = t || "neutral", n = q[r];
  return /* @__PURE__ */ e(n, { className: a("w-6 h-6", f({ variant: r })) });
}, Q = z.forwardRef(
  ({
    actionAltText: t,
    asChild: r = !1,
    actionProps: n = {},
    children: s,
    className: p = "",
    duration: d = 2e4,
    title: i,
    variant: o = "neutral",
    viewportClassName: g,
    viewportProps: u = {},
    ...x
  }, b) => {
    const v = "fixed top-[var(--spacing-24)] right-[var(--spacing-6)] flex flex-col gap-[var(--spacing-2)] w-[var(--breakpoint-sm)] max-w-[calc(100vw-var(--spacing-12))] m-0 list-none z-[1050] outline-none", h = r ? P : "a", { altText: w, ...C } = n, N = t || w || "", { className: T, ...V } = u;
    return /* @__PURE__ */ l(k, { children: [
      /* @__PURE__ */ e(
        y,
        {
          className: a($({ variant: o }), p),
          duration: d,
          "data-variant": o,
          ...x,
          children: /* @__PURE__ */ l("div", { className: "flex items-center gap-3 flex-1", children: [
            /* @__PURE__ */ e("div", { className: "flex-shrink-0", children: B(o) }),
            i && /* @__PURE__ */ e(F, { fontSize: "sm", fontWeight: "regular", children: i }),
            s && /* @__PURE__ */ e(
              A,
              {
                ref: b,
                className: "text-sm font-bold underline hover:no-underline cursor-pointer",
                altText: N,
                asChild: r,
                ...C,
                children: /* @__PURE__ */ e(h, { children: s })
              }
            ),
            /* @__PURE__ */ e(
              I,
              {
                className: "flex-shrink-0 p-1 hover:bg-gray-100 rounded transition-colors ml-auto",
                "aria-label": "Close",
                children: /* @__PURE__ */ e(M, { className: a("w-3 h-3", f({ variant: o })) })
              }
            )
          ] })
        }
      ),
      /* @__PURE__ */ e(
        j,
        {
          className: a(g || v, T),
          ...V
        }
      )
    ] });
  }
), U = ({ children: t, ...r }) => /* @__PURE__ */ e(R, { swipeDirection: "right", ...r, children: t });
export {
  Q as Toast,
  U as ToastProvider
};
